// src/components/LanguagePopup.js
import React, { useState } from 'react';

const LanguagePopup = ({ onClose }) => {
  const [selectedLanguage, setSelectedLanguage] = useState('en');

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    { code: 'ko', name: '한국어', flag: '🇰🇷' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' },
    { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' }
  ];

  const handleLanguageSelect = (code) => {
    setSelectedLanguage(code);
  };

  const handleConfirm = () => {
    localStorage.setItem('preferredLanguage', selectedLanguage);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-night-blue rounded-2xl max-w-2xl w-full border border-charcoal-gray overflow-hidden">
        {/* Header */}
        <div className="p-6 border-b border-charcoal-gray">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold text-white">Select Language</h2>
              <p className="text-text-dim mt-1">Choose your preferred language</p>
            </div>
            <button
              onClick={onClose}
              className="text-text-dim hover:text-white transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Language Grid */}
        <div className="p-6">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {languages.map(lang => (
              <button
                key={lang.code}
                onClick={() => handleLanguageSelect(lang.code)}
                className={`p-4 rounded-xl border transition-all duration-200 ${
                  selectedLanguage === lang.code
                    ? 'border-accent-blue bg-accent-blue/10'
                    : 'border-charcoal-gray hover:border-accent-blue/50 hover:bg-accent-blue/5'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-2xl">{lang.flag}</span>
                  <div className="text-left">
                    <div className="font-medium text-white">{lang.name}</div>
                    <div className="text-xs text-text-dim">{lang.code.toUpperCase()}</div>
                  </div>
                </div>
                {selectedLanguage === lang.code && (
                  <div className="mt-2 text-accent-blue text-sm font-medium">
                    ✓ Selected
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-charcoal-gray bg-charcoal-gray/30">
          <div className="flex items-center justify-between">
            <button
              onClick={onClose}
              className="px-6 py-3 bg-transparent border border-text-dim text-text-dim hover:text-white hover:border-white rounded-lg transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              className="px-6 py-3 bg-accent-blue hover:bg-blue-600 text-white font-medium rounded-lg transition-colors"
            >
              Confirm & Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguagePopup;